import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import Loading from './loading'
import 'bootstrap/dist/css/bootstrap.min.css'
import './app.css'
import ProgressBar from './ProgressBar/ProgressBar';
import { fetchPage } from './utils'
import axios from 'axios';

const App = () => {
  const [loading, setLoading] = useState(false)
  const [amount, setAmount] = useState(0)
  const [target, setTarget] = useState(0)

  const search = window.location.search
  const params = new URLSearchParams(search)
  const slug = params.get('slug')
  const type = params.get('barType')

  const handleFetchIndividual = () => Promise.resolve()
  .then(() => setLoading(true))
  .then(() => fetchPage(slug, true))
  .then((page)=> {
      setAmount(parseInt(page.totalRaisedOnline) + parseInt(page.totalRaisedOffline))
      setTarget(page.fundraisingTarget)
  })
  .then(() => setLoading(false))
  .catch(error => {
    setLoading(false)
    return Promise.reject(error)
  })

  const handleFetchTeam = () => Promise.resolve()
    .then(() => setLoading(true))
    .then(() => {
      return axios.get(`https://api.blackbaud.services/v1/team/${slug}`)
        .then(({ data }) => {
          const { donationSummary, fundraisingConfiguration } = data
          setAmount(donationSummary.totalAmount || 0)
          setTarget(fundraisingConfiguration.targetAmount || 0 )
        })
    })
    .then(() => setLoading(false))
    .catch(error => {
      setLoading(false)
      return Promise.reject(error)
    })

  useEffect(() => {
    if (type === "teamFundraising") {
      handleFetchTeam()
    } else {
      handleFetchIndividual()
    }
  }, [])

  if (loading) {
    return (
      <div className='loading-container'>
        <div className='row'>
          <div className='col-12'>
            <div className='loading'>
              <Loading size={2} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <ProgressBar
      amount={amount}
      percentage={amount / target * 100}
      target={target}
    />
  )
}

ReactDOM.render(<App />, document.getElementById('app'))









